<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
  <div class="flex flex-row items-center">
    <h2 mat-dialog-title class="!pl-0 dialog-heading">
      Search Your Location With Google Maps
    </h2>
  </div>
  <button
    mat-icon-button
    class="dialog-close-btn flex items-center justify-center"
    (click)="this._matDialogRef.close()"
  >
    <mat-icon class="text-orange-color text-xl">close</mat-icon>
  </button>
</div>

<mat-dialog-content class="mt-16 pt-4 !py-0">
  <div class="w-full">
    <form [formGroup]="this.form">
      <div class="row">
        <mat-form-field class="flex-1 form-field" appearance="fill">
          <!-- <label class="labelleading-4">Search City </label> -->
          <input
            formControlName="pickupAddress"
            type="text"
            matInput
            class="form-control"
            placeholder="Search Address/Landmark"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="off"
            #search
          />
          <mat-error>Address/Landmark is required</mat-error>
        </mat-form-field>
      </div>
      <div class="flex flex-row justify-end">
        <div class="flex flex-row items-center">
          Powered by
          <img
            src="assets/images/ui/google-maps-logo.png"
            alt="Google Maps"
            class="w-10 ml-2 h-10"
          />
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions
  class="m-0 !pb-5 !px-5 flex md:justify-center sm:justify-center justify-center"
>
  <button
    color="primary"
    (click)="this._matDialogRef.close(this.form.get('pickupAddress').value)"
    class="!bg-blue-theme-color !px-6 !h-11 text-white-color ml-auto mr-0"
    mat-flat-button
    [disabled]="this.form.invalid"
  >
    <span class="btn-text">Save</span>
  </button>
</mat-dialog-actions>
